<template>
<div>
  <el-dialog
    title="添加转运信息"
    :visible.sync="dialogVisible"
    width="900px"
    :before-close="handleClose">
   <div style="display: flex;">
     <div style="width: 50%;">
        <p class="cvd1">转运信息</p>

          <div class="itme23">
              <span class="s_ere"></span>
            <el-checkbox v-model="from.is_original_order_sn">原单号 </el-checkbox>
          </div>
          <div class="itme23">
              <span class="s_ere">转运单号</span>
              <span class="s_ip2"><el-input v-model="from.transfer_order_sn"  ></el-input></span>
          </div>
          <div class="itme23">
              <span class="s_ere">手机</span>
              <span class="s_ip2"><el-input v-model="from.transfer_mobile" ></el-input></span>
          </div><div class="itme23">
              <span class="s_ere">电话</span>
              <span class="s_ip2"><el-input v-model="from.transfer_telephone" ></el-input></span>
          </div><div class="itme23">
              <span class="s_ere">地址</span>
              <span class="s_ip2"><el-input v-model="from.transfer_address" ></el-input></span>
          </div>
          <div class="itme23">
              <span class="s_ere">预计送达时间</span>
              <span class="s_ip2"><el-date-picker
      v-model="from.expected_delivery_time"
      type="date"
      placeholder="选择日期">
    </el-date-picker></span>
          </div>

     </div>
     <div style="width: 50%;">
          <p class="cvd1">分拨中心信息</p>

                <div class="itme23">
                    <span class="s_ere">分拨名称</span>
                    <span class="s_ip2"><el-input v-model="from.name"  ></el-input></span>
                </div>
                <div class="itme23">
                    <span class="s_ere">手机</span>
                    <span class="s_ip2"><el-input v-model="from.center_telephone" ></el-input></span>
                </div><div class="itme23">
                    <span class="s_ere">电话</span>
                    <span class="s_ip2"><el-input v-model="from.center_mobile" ></el-input></span>
                </div><div class="itme23">
                    <span class="s_ere">地址</span>
                    <span class="s_ip2"><el-input v-model="from.center_address" ></el-input></span>
                </div>

     </div>
   </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="add">确 定</el-button>
    </span>
  </el-dialog>
</div>

</template>

<script>
export default {
   data (){
       return {
      dialogVisible:false,
      from:{
     id:0,
     name:'',
     center_telephone:'',
     center_mobile:'',
     center_address:'',
     is_original_order_sn:false,
     transfer_order_sn:'',
     transfer_mobile:'',
     transfer_telephone:'',
     transfer_address:'',
     expected_delivery_time:'',
      }
       }
   },

   methods: {
     open(id){
       this.from.id=id;
       this.dialogVisible=true;
     },
     add(){

       this.$post('OrderLogisticsSpeed' ,this.from)
           .then(data => {
              this.$message.success('添加成功');
               this.dialogVisible=false;
           } , error => {
               this.loading = false;
               this.$message.error(error);
           });
        //this.dialogVisible=false;
     },
    handleClose(done) {
        this.$confirm('确认关闭？')
          .then(_ => {
            done();
          })
          .catch(_ => {});
      }
   },
   created() {

   },
   mounted() {

   }
}
</script>

<style scoped lang='less'>
  .itme23{
  margin-top: 20px;
  }
  .s_ere{
    width: 100px;
    display: inline-block;
    text-align: right;
    margin-right: 10px;
  }
  .cvd1{
    font-size: 14px;
    color: #000;
    font-weight: 600px;
  }
  .s_ip2{
    display: inline-block;
    width: 300px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/orderList/components/transitEntry.vue